module.exports = __webpack_public_path__ + "static/media/merise_image_presentation.ee591f63.png";